import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseClient } from 'entities/Clients/api/types'
import { type ISubscriptionStatus } from 'entities/Subscription'

export class RowClient extends RowBase<IResponseClient> {
  constructor(origin: IResponseClient) {
    super(origin)
    makeObservableRowBase(this, {
      clientName: computed,
      email: computed,
      subscriptionStatus: computed,
      planType: computed,
      credits: computed,
      brandStatus: computed,
      campaignStatus: computed,
      groups: computed,
      accessibleOrganization: computed,
    })
  }

  get clientName() {
    return this.origin.name
  }

  get email() {
    return this.origin.owner?.profile?.email
  }

  get subscriptionStatus(): ISubscriptionStatus {
    return this.origin.subscriptions?.[0]?.status || 'past_due'
  }

  get planType() {
    const sub = this.origin.subscriptions?.[0]
    return sub?.plan?.name || sub?.stripe_plan || ''
  }

  get credits() {
    return this.origin.account_credits
  }

  get brandStatus() {
    return this.origin.a2p_brand?.status || null
  }

  get campaignStatus() {
    return this.origin.use_case_campaign?.status || null
  }

  get groups() {
    return this.origin.groups || []
  }

  get accessibleOrganization() {
    return this.origin.accessible_organization
  }
}
